import "./style.scss"
import React, { Component } from 'react'
import { Menu, Icon, Row, Col, Dropdown } from 'antd'
import { map, find } from 'lodash'
import Flag from "react-flags";

import logic, { getMenu } from './logic'
import i18n from '~/i18n'
const __ = i18n.t.bind(i18n);


@logic
export default class MainMenu extends Component {
  constructor(props) {
    super(props);

    this.state = {
      menuMinHeight: 500,
    }
  }

  handleLanguageMenuClick = (e) => {
    const { changeLanguage } = this.props.actions;
    const { key, ...others } = e;
    changeLanguage(key);
  };

  componentDidMount() {
    this.resizeEventListener = {
      handleEvent: (event) => {
        this.handleResize()
      }
    };

    if(typeof window !== 'undefined') {
      window.addEventListener('resize', this.resizeEventListener)
    }

    this.handleResize();
  }

  componentWillUnmount() {
    if(typeof window !== 'undefined' && this.resizeEventListener) {
      window.removeEventListener('resize', this.resizeEventListener);
    }
  }

  handleResize() {
    if(typeof window !== 'undefined') {
      let minHeight = window.innerHeight;
      const root = document.querySelector('#root .main-content');
      if(root) {
        if(minHeight < root.scrollHeight) {
          minHeight = root.scrollHeight;
        }
      }
      this.setState({menuMinHeight: minHeight-126});
    }
  }

  clickMenu = (e) => {
    const menu = getMenu();
    const { clickMenuItem, logout } = this.props.actions;
    if(e.key === 'logout') {
      logout();
    }else {
      const item = find(menu, {key: e.key});

      if(item) {
        clickMenuItem(item.url);
      }
    }
  };

  clickSubMenu = (e) => {
    const { subMenu } = this.props;
    const { clickMenuItem } = this.props.actions;

    if(subMenu) {
      const item = find(subMenu, {key: e.key});

      if(item) {
        clickMenuItem(item.url);
      }
    }
  };

  render () {
    const menu = getMenu();
    const { selectedKeys, subMenu, languages, language } = this.props;
    const { menuMinHeight } = this.state;

    let subMenuElem;
    const menuItems = map(menu, (item) => {
      const { key, label, icon } = item;
      return (
        <Menu.Item key={ key }>
          <span>
            { icon ? <Icon type={ icon }/> : null }
            { !subMenu ? <span>{ label }</span> : null }
          </span>
        </Menu.Item>
      )
    });

    if(subMenu) {
      const items = map(subMenu, (child) => {
        return (
          <Menu.Item key={ child.key }>{ child.label }</Menu.Item>
        )
      });
      subMenuElem = (
        <Menu
          theme="dark"
          mode="inline"
          className="submenu"
          selectedKeys={ selectedKeys }
          onClick={ this.clickSubMenu }
          style={{minHeight: `${menuMinHeight}px`}}
          inlineIndent={20}
        >
          { items }
        </Menu>
      )
    }

    const languageMenu = (
      <Menu style={{width: 240}} onClick={this.handleLanguageMenuClick}>
        {map(languages, (lng) => {
          return <Menu.Item key={ lng.value }>
            <span style={{visibility: language.value === lng.value ? 'visible': 'hidden'}}>✓ </span>
            { lng.label }
          </Menu.Item>
        }) }
      </Menu>
    );
    return (
      <Row>
        <Col span={ subMenuElem ? 6 : 24 }>
          <Menu
            theme="dark"
            mode="inline"
            className={ subMenuElem ? 'collapsed' : ''}
            selectedKeys={ selectedKeys }
            onClick={ this.clickMenu }
            style={{minHeight: `${menuMinHeight}px`}}
          >
            { menuItems }
            <Menu.ItemGroup className="menu-logout">
                <Menu.Item key="language">
                  <Dropdown overlay={languageMenu} trigger={['click']} placement="topLeft">
                    <span>
                      <Flag
                        name={ language.country }
                        format="png"
                        shiny={true}
                        pngSize={32}
                        width={16}
                        height={16}
                        basePath={"/assets/img/flags"}
                      />
                      { !subMenu ? <span>{ __('Language') }</span> : null }
                    </span>
                  </Dropdown>
                </Menu.Item>
              <Menu.Item key="logout">
                <span>
                  <Icon type="logout"/>
                  { !subMenu ? <span>{ __('Logout') }</span> : null }
                </span>
              </Menu.Item>
            </Menu.ItemGroup>
          </Menu>
        </Col>
        { subMenuElem ?
          <Col span={ 18 }>
            { subMenuElem }
          </Col>
        : null }
      </Row>
    )
  }
}
